import { formatDataTest } from '@/common/dataTest/DataTest';
import { useInDialog } from '@/common/dialog/DialogScopeContext';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useFormFieldDef } from '../hooks/useFormFieldDef';

export const DateFormField = ({ fieldDef }) => {
  const { value, setValue, onBlur, error, helperText, label, disabled } = useFormFieldDef(fieldDef);
  const inDialog = useInDialog();

  const dateValue = useMemo(() => {
    if (!value) return null;
    return dayjs(String(value), 'YYYYMMDD');
  }, [value]);

  const handleChange = (value) => {
    if (!value) {
      setValue(null);
      return;
    }

    const date = value.format('YYYYMMDD');
    setValue(date);
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        disabled={disabled}
        label={label}
        sx={{ width: '100%' }}
        desktopModeMediaQuery="@media (min-width: 0px)" // Prevent mobile version
        slotProps={{
          actionBar: {
            actions: ['clear'],
          },
          textField: {
            fullWidth: true,
            variant: 'standard',
            helperText,
            error,
            onBlur,
            'data-test-id': formatDataTest(inDialog ? 'dialog' : 'main', 'form-field', fieldDef.displayName)
          },
        }}
        value={dateValue}
        onChange={handleChange}
      />
    </LocalizationProvider>
  )
}